import { saveAs } from 'file-saver';
import { FileWithPath } from 'react-dropzone';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const downloadBase64Data = (base64String: string, fileName: string) => {
  const file: File = convertBase64ToFile(base64String, fileName);
  saveAs(file, fileName);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const toBase64 = async(file: File | FileWithPath) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

export const convertBase64ToFile = (base64String: string, fileName: string): File => {
  const arr = base64String.split(',');
  const meta = arr[0];
  const blob = arr[1];
  if(meta && blob){
    const split_meta = meta.match(/:(.*?);/);
    if(split_meta){
      const mime = split_meta[1];
      const bstr = atob(blob);
      let n = bstr.length;
      const uint8Array = new Uint8Array(n);
      while (n--) {
        uint8Array[n] = bstr.charCodeAt(n);
      }
      const file = new File([ uint8Array ], fileName, { type: mime });
      return file;
    }
  }
  return new File([], 'test');
};
